"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Abstract Class Interface responsible for getting main KB data including all categories, categoryFields and etc.
 * @author Anania.Mikaelyan
 */
var KbService = /** @class */ (function () {
    function KbService() {
    }
    return KbService;
}());
exports.KbService = KbService;
//# sourceMappingURL=kb.service.js.map